const ALIGNMENTS_ENUMS = {
  START: "start",
  LEFT: "start",
  CENTER: "center",
  END: "end",
  RIGHT: "end"
};
export {
  ALIGNMENTS_ENUMS
};
//# sourceMappingURL=constants.mjs.map
